require("flatpickr/dist/flatpickr.min.css");
require("flatpickr/dist/themes/airbnb.css");


const flatpickr = require("flatpickr").default;
const Arabic = require("flatpickr/dist/l10n/ar.js").Arabic;


flatpickr("#reservation_date", {
    locale: Arabic,
    position: "auto right",
    dateFormat: "Y-m-d",
    minDate: "today",
    disable: [
        ...disabledDates,
    ]
});